import styles from './StatisticsWidget.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import { FaUsers, FaClinicMedical, FaSync, FaUserMd, FaPowerOff, FaMedkit, FaCog, FaSitemap } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const StatisticsWidget = ({ dateRange }) => {
    const { startDate, endDate } = dateRange;
    const [ stats, setStats ] = useState({});
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            setStats(res)
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        setIsLoaded(true)
    }, [ stats ])

    const getData = async () => {
        const data = await api.get(`dashboard/statistics?startDate=${startDate}&endDate=${endDate}`)
        return data.data.data;
    }

    return (<>
        <div className={ styles.container }>
            <div className={ styles.statBox }>
                <Link to="/clinics" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaClinicMedical /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.clinics }</div>
                                <h3 className={ styles.statLabel }>Clinics</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/patients" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaUsers /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.patients }</div>
                                <h3 className={ styles.statLabel }>Total Patients</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/staff" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaUserMd /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.staffs }</div>
                                <h3 className={ styles.statLabel }>Staff</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/equipment/platforms" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaCog /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.machines }</div>
                                <h3 className={ styles.statLabel }>Platforms</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/equipment/applicators" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaCog /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.applicators }</div>
                                <h3 className={ styles.statLabel }>Applicators</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div className={ styles.statBox }>
                <Link to="/treatments" className='w-100'>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaMedkit /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.treatments > 0 && stats.treatments.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }</div>
                                <h3 className={ styles.statLabel }>Treatments</h3>
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    </>)
}


export default StatisticsWidget;